import { render, staticRenderFns } from "./ArticleGrayGrid.vue?vue&type=template&id=601c5aa0&scoped=true&"
import script from "./ArticleGrayGrid.vue?vue&type=script&lang=js&"
export * from "./ArticleGrayGrid.vue?vue&type=script&lang=js&"
import style0 from "./ArticleGrayGrid.vue?vue&type=style&index=0&id=601c5aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c5aa0",
  null
  
)

export default component.exports